<template>
  <form novalidate id="email_form" @submit.prevent="forward">
    <hg-title hg-title-name="Forward Report" />

    <p v-if="forwardDefaults.canForward" class="description">
      Use this form to email a link of
      your report to family, contractors or anyone else.
    </p>
    <p v-if="!forwardDefaults.canForward" class="description">
      The report forwarding permission for this report has not been
      enabled. Use this form to send a request to your home inspector to forward the
      home inspection to someone else.
    </p>

    <Alert
      v-if="showErrors"
      id="confirmation-error"
      type="error"
      @close="showErrors = false">
      <div v-for="error in errors.items" :key="error.id">
        {{error.msg}}
      </div>
    </Alert>

      <label for="to">To</label>
      <v-combobox
        v-model="forwardDefaults.to"
        v-validate="'required|email'"
        :disabled="!forwardDefaults.canForward"
        :items="[]"
        class="emails"
        chips
        flat
        hint="Press the Tab key between email addresses"
        id="to"
        multiple
        name="email"
        persistent-hint
        solo>
        <template slot="selection" slot-scope="data">
          <v-chip :selected="data.selected" close @input="remove(data.item)">
            <strong>{{data.item}}</strong>&nbsp;
          </v-chip>
        </template>
      </v-combobox>

      <label for="subject">Subject</label>
      <input
        type="text"
        id="subject"
        name="subject"
        class="form-field"
        v-validate="'required'"
        v-model="forwardDefaults.subject">

      <label for="message">Message</label>
      <ckeditor
        v-model="forwardDefaults.body"
        v-validate="{ required: true }"
        class="form-field"
        id="message"
        name="message" />
      <button class="btn-primary btn-submit" type="submit">Send Email</button>
    </form>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';
import Title from '../Shared/Title.vue';

export default {
  components: {
    'hg-title': Title,
    Alert,
  },
  data() {
    return {
      showConfirmation: false,
      showErrors: false,
    };
  },
  props: {
    hgForwardDefaults: {
      type: Object,
      required: true,
    },
  },
  computed:
  {
    forwardDefaults() {
      return this.hgForwardDefaults;
    },
  },
  methods: {
    remove(item) {
      this.forwardDefaults.to.splice(this.forwardDefaults.to.indexOf(item), 1);
      this.forwardDefaults.to = [...this.forwardDefaults.to];
    },
    forward() {
      setTimeout(() => {
        // setTimeout allows execution of the combo box for
        // the 'to' field to complete before validation runs
        this.$validator.validateAll()
          .then(results => {
            if (results) {
              this.$emit('forward', this.forwardDefaults);
            } else {
              this.showErrors = true;
            }
          });
      }, 0);
    },
  },
  watch: {
    forwardDefaults: {
      handler() {
        this.showConfirmation = false;
      },
      deep: true,
    },
    hgForwardComplete(newVal) {
      this.showConfirmation = newVal;
    },
    showConfirmation(newVal) {
      if (newVal) {
        this.$scrollTo('.info');
      }
    },
    // eslint-disable-next-line object-shorthand
    'errors.items'(newVal) {
      if (newVal.length < 1) {
        this.showErrors = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.form-field {
  width: 100%;
}

.description {
  font-size: 1.143rem;
  margin-bottom: 30px;
}

.btn-submit {
  display: block;
  margin: 40px auto 0;
}

.emails {
  ::v-deep .v-input__append-inner {
    display: none;
  }

  ::v-deep .v-select__selections input {
    border: none;
  }

  ::v-deep .v-input__slot {
    border: solid 1px rgba($theme-color-black, 0.15);
    border-radius: 5px;
  }

  &.v-input--is-focused ::v-deep .v-input__slot {
    border: 1px solid $theme-color-primary;
    box-shadow: 0 0 1px $theme-color-primary;
  }
}

@media all and (max-width: 655px) {
  .v-chip {
    font-size: 0.714rem;
  }
}
</style>

<style lang="scss">
  /* fix for missing side borders on ckEditor */
  .cke_chrome {
    border: 2px solid #d1d1d1 !important;
  }

  .v-input--is-disabled .v-input__slot {
    background-color: #d1d1d1 !important;
  }
</style>
